import SvgIcon from './styled'

export interface IconProps {
  width: number
}

interface IconTypeProps extends IconProps {
  fill?: string
  viewBox?: string
  xmlns?: string
  alt?: string
  children: object
}

export interface PhoneContentIcon extends React.ReactElement {
  props: IconTypeProps
}

const Icon = (props: IconTypeProps): PhoneContentIcon => <SvgIcon {...props} />

export default Icon
